import React, { useEffect, useState } from "react";
import { IAppPropsWithRoute } from "../../../common/types";
import { withRouter, useHistory } from 'react-router-dom';
// Mui
import {
  Grid,
  Checkbox,
  Button,
  FormHelperText,
  LinearProgress,
  GridList,
  GridListTile,
  GridListTileBar,
  withWidth,
  isWidthUp,
} from "@material-ui/core";
// Styles
import { useStyles } from "../styles";
// IndexedDb
import IndexedDb from "../IndexedDb";
import api from "../../../store/api";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { consts } from "../../../common/consts";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import * as Icons from "../iconComponents";
import { useDispatch } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PcrSlice, { setpcrstate } from "../../../store/modules/PcrSlice";
import { pcrstate } from "../../../store/modules/PcrSlice";
import { v4 as uuidv4 } from "uuid";
interface PcrWidgetProps extends IAppPropsWithRoute {}
interface Files {
  Key: string;
  img: any;
  Title: string;
}
const SubFormWidget: React.FC<PcrWidgetProps> = (props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { authStore } = useSelector((state: RootState) => state);
  const [indexdb, setIndexdb] = useState("");
  const [showPhotoButton, setShowPhotoButton] = useState(false);
  const [fileErrorMsg, setFileErrorMsg] = React.useState("");
  const [filePaperPCR, setFilePaperPCR] = useState(" ");
  const formData = new FormData();
  const [visibileProgress, setVisibileProgress] = React.useState(false);
  const [Attachement,setAttachement] = React.useState<Files[]>([]);
  const [PaperPCRCount, setPaperPCRCount] = useState(0);
  const pcr = useSelector(pcrstate);

  const {
    handleSubmit,
    watch,
    errors,
    control,
    formState,
    setValue,
    getValues,
    setError,
  } = useFormContext();
  useEffect(() => {
    let db: any = null;
    db = localStorage.getItem("PatientDB");
    setIndexdb(db);
    getIndexDBValues();
  }, []);

  React.useEffect(() => {      
    if(pcr.ShowImg)
    {
      getIndexDBValues();
    }
}, [pcr.ShowImg])

React.useEffect(() => {
  if (showPhotoButton) {
    dispatch(setpcrstate({ name: "ValidateAllFields", value: false }));
  } else {
    dispatch(setpcrstate({ name: "ValidateAllFields", value: true }));
  }
}, [showPhotoButton]);



  const validateImage = async (value: any) => {
    let db = localStorage.getItem("PatientDB");
    if (db != null && db != "") {
      const indexedDb = new IndexedDb(db);
      await indexedDb.createObjectStore(indexedDb.patientcarerecord);
      let AttachementLst = await indexedDb.getAllValue("Attachement");
      let acceptedFormats = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/heic",
      ];
      for (let i = 0; i < AttachementLst.length; i++) {
        if (!acceptedFormats.includes(AttachementLst[i].value.img.type)) {
          return "Only JPEG and PNG images are allowed for Attachments.";
        }
      }
    }
    return true;
  };

  const handleFileChange = (event: any) => {
    // Access the selected file using the event object
    let acceptedFormats = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/heic",
    ];
    const file = event.target.files[0];
    if (file) {
      setFileErrorMsg("");
      if (file.type && acceptedFormats.includes(file.type)) {
        // Perform your desired actions with the file
        SavePaperPCRFile(event);
      } else {
        setFileErrorMsg("Invalid file format!");
        setTimeout(() => {
          setFileErrorMsg("");
        }, 8000);
      }
      // Reset the file input value to an empty string
      event.target.value = "";
    }
  };

  const GenerateRandomGuid = () => {
    const newGuid = uuidv4();
    return newGuid;
  };

  const SavePaperPCRFile = async (event: any) => {
    dispatch(setpcrstate({ name: "ShowImg", value: false }));

    const file = event.target.files[0];
    const indexedDb = new IndexedDb(indexdb);

    let Keys: number = 0;
    let updatedFileName = GenerateRandomGuid() + "_" + file.name;
    const updatedFile = new File([file], updatedFileName, {
      type: file.type,
    });

    setPaperPCRCount((prevCount) => prevCount + 1);
    Keys = PaperPCRCount + 1;

    if (indexdb != null || indexdb != "") {
      const indexedDb = new IndexedDb(indexdb);
      const base64 = await indexedDb.convertToBase64(file);

      await indexedDb.createObjectStore(indexedDb.patientcarerecord);
      await indexedDb.putValue(
        "Attachement",
        {
          img: updatedFile,
          Base64: base64,
          title: "Paper PCR",
          Key: "PaperPCRImage" + Keys,
          Keyvalue: 6,
          Patid: 0,
        },
        "PaperPCRImage" + Keys
      );
    }

    formData.append("file", updatedFile);
    //await AttachmentsRemove();
    await saveFiletoBlobStorage();
    await getIndexDBValues();
    dispatch(setpcrstate({ name: "ShowImg", value: true }));
  };


  const SaveToIndexDB = async (Key: any, value: any): Promise<void> => {
    let indexDB = localStorage.getItem("PatientDB");
    if (indexDB != null && indexDB != "") {
        const indexedDb = new IndexedDb(indexDB);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        await indexedDb.deleteValue('Patientidentification', Key);
        await indexedDb.putValue('Patientidentification', { column: value, Patid: 0 }, Key);
    }
}


  const getIndexDBValues = async (): Promise<void> => {
    let db: any = null;
    db = localStorage.getItem("PatientDB");
    if (db != null && db != "") {
      const indexedDb = new IndexedDb(db);
      await indexedDb.createObjectStore(indexedDb.patientcarerecord);
      let valPaperPCRs = await indexedDb.getAllValue("Attachement");
      let img: any = []; let paperPCRCnt = 0;
      for (let i = 0; i < valPaperPCRs.length; i++) {
        if (valPaperPCRs[i].Key.includes("PaperPCR")) {
          paperPCRCnt = paperPCRCnt + 1;
          let res = valPaperPCRs[i].value.img;
          img.push({
            Key: valPaperPCRs[i].Key,
            img: res,
            Title: "Paper PCR",
          });
          setShowPhotoButton(true);
          dispatch(setpcrstate({ name: "ValidateAllFields", value: false }));
        }
      }
      setPaperPCRCount(paperPCRCnt)
      setAttachement(img);

      let val = await indexedDb.getAllValue('Patientidentification'); 
      if (val.length > 0) {
          let paperPCR = val.filter((x: any) => x).find((s: any) => s.Key==="PaperPCRCheckbox")
          if (paperPCR != null) {
              setShowPhotoButton(paperPCR.value.column);
          }
      }
    }
  };

  const saveFiletoBlobStorage = async (): Promise<void> => {
    try {
      setVisibileProgress(true);
      const res = await api.pushFileToBlobStorage("", formData);
      if (res?.error) {
        alert("Error Occurs while Uploading");
      }
      setVisibileProgress(false);
      formData.delete("file");
    } catch (error) {
      setVisibileProgress(false);
    }
  };

  const getGridListCols = (): number => {
    if (isWidthUp("xl", props.width)) {
      return 5.5;
    }
    if (isWidthUp("lg", props.width)) {
      return 4.5;
    }
    if (isWidthUp("md", props.width)) {
      return 3.5;
    }
    if (isWidthUp("sm", props.width)) {
      return 2.5;
    }
    return 1.5;
  };

  const handlePaperPCRDelete = async (Key:any): Promise<void> => {    
    dispatch(setpcrstate({ name: "ShowImg", value: false }));   
    if(indexdb!=null || indexdb !="")
    {
        const indexedDb = new IndexedDb(indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
        await indexedDb.deleteValue('Attachement', Key);  
    }  
    getIndexDBValues();
    dispatch(setpcrstate({ name: "ShowImg", value: true }));   
}

  return (
    <div>
      <div>
        <FormControlLabel
          key="PaperPCRCheckbox"
          control={<Checkbox className={classes.checkboxInput} />}
          label="Attach photo(s) of paper PCR instead of completing a standard PCR"
          checked={showPhotoButton}
          onChange={(e) => {
            SaveToIndexDB("PaperPCRCheckbox", !showPhotoButton);
            setShowPhotoButton(!showPhotoButton);
          }}
          style={{ margin: 0 }}
        />
      </div>
      {showPhotoButton && (
        <div className={classes.pcrPaper}>
          <div>
            <Controller
              control={control}
              name="PaperPCR"
              defaultValue=""
              render={({ onChange, onBlur, value, name }) => (
                <>
                  <Button
                    variant="contained"
                    className={classes.yellowBtn} 
                    component="label"
                  >
                    Add Photos
                    <input
                      {...value}
                      name={name}
                      type="file"
                      onChange={handleFileChange}
                      accept="image/*"
                      hidden
                    />
                  </Button>
                  <FormHelperText error={errors.Attachements}>
                    {errors.Attachements ? errors.Attachements.message : ""}
                  </FormHelperText>
                  {!!fileErrorMsg && (
                    <FormHelperText error={true}>{fileErrorMsg}</FormHelperText>
                  )}
                  {visibileProgress && (
                    <div style={{ width: "100%" }}>
                      <LinearProgress />
                    </div>
                  )}
                </>
              )}
              rules={{
                validate: validateImage,
              }}
            />
          </div>
          <div>
            <div className={classes.attachmentsFormList}>
              <GridList
                spacing={15}
                className={"gridList"}
                cols={getGridListCols()}
              >
                {Attachement.map((item, index) => (
                  <GridListTile
                    key={index}
                    rows={1}
                    style={{ height: "250px" }}
                  >
                    <GridListTileBar
                      titlePosition="top"
                      actionPosition="right"
                      title={item.Title}
                      classes={{
                        root: "titleBar",
                        title: "title",
                        titleWrap: "wrap",
                      }}
                      actionIcon={
                        <div
                          className={"removeBtn"}
                          onClick={(event) => {
                            handlePaperPCRDelete(item.Key);
                          }}
                        >
                          <Icons.CloseLightIcon />
                        </div>
                      }
                    />
                    {item.img != null && (
                      <img
                        src={URL.createObjectURL(item.img)}
                        alt="attachment"
                        className={"attachment"}
                      />
                    )}
                  </GridListTile>
                ))}
              </GridList>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default withWidth()(React.memo(withRouter(SubFormWidget)));
